import { Routes, Route } from "react-router-dom";
import AuthRoutes from "./auth-routes";
import { Fragment } from "react/jsx-runtime";
import DashboardRoutes from "./dashboard-routes";
import { useSelector } from "react-redux";
import Loader from "components/particles/loader";

const AppRoutes = () => {
  const { isLoading } = useSelector((state: any) => state.sharedReducer);
  return (
    <Fragment>
      {isLoading && <Loader/>}
      <Routes>
        <Route path="/*" Component={DashboardRoutes} />
        <Route path="/auth/*" Component={AuthRoutes} />
      </Routes>
    </Fragment>
  );
};

export default AppRoutes;
